import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cad73dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overviewCon" }
const _hoisted_2 = { class: "wrapper mt10" }
const _hoisted_3 = { class: "overview m-b-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Delay Request Count：", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Callback Request Count：", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Waiting for Approved：", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Waiting for Approved：", -1))
const _hoisted_8 = { class: "feature-wrap m-b-8 clearfix" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Request Code", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Request Type", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Request Date", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Status", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Dealer Code", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Dealer Name", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "VIN", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " ", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_19 = { class: "table" }
const _hoisted_20 = { class: "tableBtn" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Reject")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Approve")
const _hoisted_24 = { class: "table-wrap" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("发票")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("行驶证")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("关系证明")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("延期证明")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Detail")
const _hoisted_30 = {
  key: 0,
  class: "table-pagination"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode("下载文件")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("下载文件")
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_notice_modal = _resolveComponent("notice-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_tabs, {
        type: "card",
        activeKey: _ctx.activeKey,
        "onUpdate:activeKey": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.activeKey) = $event)),
        onChange: _ctx.tabChange
      }, {
        default: _withCtx(() => [
          (_ctx.$btnPermissions('DM0034', '/claimDelay/SIPOClaim'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "1",
                tab: "Retail"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("span", {
                        class: "num",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.quickSearch('1')))
                      }, _toDisplayString(_ctx.overviewValue.delayRequset), 1),
                      _hoisted_5,
                      _createElementVNode("span", {
                        class: "num",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.quickSearch('2')))
                      }, _toDisplayString(_ctx.overviewValue.callBackRequset), 1),
                      _hoisted_6,
                      _createElementVNode("span", {
                        class: "num",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.quickSearch('1', '2')))
                      }, _toDisplayString(_ctx.overviewValue.delayRequsetApproved), 1),
                      _hoisted_7,
                      _createElementVNode("span", {
                        class: "num",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.quickSearch('2', '2')))
                      }, _toDisplayString(_ctx.overviewValue.callBackRequsetApproved), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_a_space, {
                        direction: "vertical",
                        size: _ctx.spaceSize,
                        style: {"margin-right":"15px","width":"229px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _createVNode(_component_a_input, {
                            value: _ctx.seachParams.applyCode,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.seachParams.applyCode) = $event)),
                            placeholder: "Please Input"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["size"]),
                      _createVNode(_component_a_space, {
                        direction: "vertical",
                        size: _ctx.spaceSize,
                        style: {"margin-right":"15px","width":"229px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _createVNode(_component_a_select, {
                            value: _ctx.seachParams.applyType,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.seachParams.applyType) = $event)),
                            style: {"width":"229px"},
                            ref: "select",
                            placeholder: "Please Select",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applyTypeList, (rt) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: rt.value,
                                  key: rt.value,
                                  title: rt.title
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(rt.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "title"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["size"]),
                      _createVNode(_component_a_space, {
                        direction: "vertical",
                        size: _ctx.spaceSize,
                        style: {"margin-right":"15px","width":"229px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _createVNode(_component_a_date_picker, {
                            style: {"width":"229px"},
                            value: _ctx.seachParams.applyDate,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.seachParams.applyDate) = $event)),
                            placeholder: "Please Select",
                            valueFormat: "YYYY-MM-DD",
                            format: "YYYY/MM/DD"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["size"]),
                      _createVNode(_component_a_space, {
                        direction: "vertical",
                        size: _ctx.spaceSize,
                        style: {"margin-right":"15px","width":"229px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _createVNode(_component_a_select, {
                            style: {"width":"229px"},
                            value: _ctx.seachParams.status,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.seachParams.status) = $event)),
                            placeholder: "Please Select",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (st) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: st.value,
                                  key: st.value,
                                  title: st.title
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(st.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "title"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["size"]),
                      _createVNode(_component_a_space, {
                        direction: "vertical",
                        size: _ctx.spaceSize,
                        style: {"margin-right":"15px","width":"229px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13,
                          _createVNode(_component_a_input, {
                            value: _ctx.seachParams.dealerCode,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.seachParams.dealerCode) = $event)),
                            placeholder: "Please Input"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["size"]),
                      _createVNode(_component_a_space, {
                        direction: "vertical",
                        size: _ctx.spaceSize,
                        style: {"margin-right":"15px","width":"229px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _createVNode(_component_a_input, {
                            value: _ctx.seachParams.dealerNameEn,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.seachParams.dealerNameEn) = $event)),
                            placeholder: "Please Input"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["size"]),
                      _createVNode(_component_a_space, {
                        direction: "vertical",
                        size: _ctx.spaceSize,
                        style: {"margin-right":"15px","width":"229px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _createVNode(_component_a_input, {
                            value: _ctx.seachParams.vinNo,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.seachParams.vinNo) = $event)),
                            placeholder: "Please Input"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["size"]),
                      _createVNode(_component_a_space, {
                        direction: "vertical",
                        class: "right-button",
                        size: _ctx.spaceSize
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16,
                          _createElementVNode("div", null, [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              class: "mr10",
                              onClick: _ctx.getTableData
                            }, {
                              default: _withCtx(() => [
                                _hoisted_17
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_a_button, {
                              class: "mr10",
                              onClick: _ctx.reset
                            }, {
                              default: _withCtx(() => [
                                _hoisted_18
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["size"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_a_button, {
                          class: "mr10",
                          onClick: _ctx.exportExcel
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          class: "mr10",
                          onClick: _ctx.reject
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _ctx.approve
                        }, {
                          default: _withCtx(() => [
                            _hoisted_23
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_a_table, {
                          class: "ant-table-striped",
                          rowClassName: 
                  (record, index) => (index % 2 === 1 ? 'table-striped' : null)
                ,
                          rowKey: "id",
                          "row-selection": {
                  selectedRowKeys: _ctx.state.selectedRowKeys,
                  onChange: _ctx.onSelectChange,
                },
                          columns: _ctx.columns,
                          "data-source": _ctx.tableData,
                          scroll: {
                  x: 1490,
                  y: _ctx.tableHeight,
                },
                          pagination: false
                        }, {
                          applyType: _withCtx(({ record }) => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.ApplyListCheck[record.applyType]), 1)
                          ]),
                          status: _withCtx(({ record }) => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.StatusListCheck[record.status]), 1)
                          ]),
                          document: _withCtx(({ record }) => [
                            _createVNode(_component_a_button, {
                              type: "link",
                              onClick: ($event: any) => (
                      _ctx.viewPicEvent(record.vinNo, 'invoice', record.dealerCode)
                    ),
                              disabled: !record.invoicePath
                            }, {
                              default: _withCtx(() => [
                                _hoisted_25
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"]),
                            _createVNode(_component_a_divider, { type: "vertical" }),
                            _createVNode(_component_a_button, {
                              type: "link",
                              onClick: ($event: any) => (
                      _ctx.viewPicEvent(record.vinNo, 'license', record.dealerCode)
                    ),
                              disabled: !record.drivingLicensePath
                            }, {
                              default: _withCtx(() => [
                                _hoisted_26
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"]),
                            _createVNode(_component_a_divider, { type: "vertical" }),
                            _createVNode(_component_a_button, {
                              type: "link",
                              onClick: ($event: any) => (
                      _ctx.viewPicEvent(record.vinNo, 'relationProof', record.dealerCode)
                    ),
                              disabled: !record.relationProofPath
                            }, {
                              default: _withCtx(() => [
                                _hoisted_27
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"]),
                            _createVNode(_component_a_divider, { type: "vertical" }),
                            _createVNode(_component_a_button, {
                              type: "link",
                              onClick: ($event: any) => (
                      _ctx.viewPicEvent(record.vinNo, 'prove', record.dealerCode)
                    ),
                              disabled: !record.delayProvePath
                            }, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"])
                          ]),
                          failReason: _withCtx(({ record }) => [
                            _createVNode(_component_a_button, {
                              type: "link",
                              onClick: ($event: any) => (_ctx.openModal(record))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_29
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        }, 8, ["rowClassName", "row-selection", "columns", "data-source", "scroll"])
                      ])
                    ])
                  ]),
                  (_ctx.tableData && _ctx.tableData.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_a_pagination, {
                          total: _ctx.pagination.total,
                          "show-total": (total) => `共 ${total} 条`,
                          onChange: _cache[11] || (_cache[11] = (page, pageSize) => _ctx.pageChange(page)),
                          onShowSizeChange: _cache[12] || (_cache[12] = (page, pageSize) => _ctx.sizeChange(page, pageSize)),
                          "show-size-changer": "",
                          current: _ctx.pagination.currentPage,
                          pageSize: _ctx.pagination.pageSize,
                          pageSizeOptions: ['10', '20', '30', '40', '50']
                        }, null, 8, ["total", "show-total", "current", "pageSize"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.$btnPermissions('DM0033', '/claimDelay/SIPOClaim'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "2",
                tab: "Claim"
              }))
            : _createCommentVNode("", true),
          (_ctx.$btnPermissions('DM0035', '/claimDelay/SIPOClaim'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "3",
                tab: "UC"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["activeKey", "onChange"])
    ]),
    (_ctx.pictureModal.isImage)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          visible: _ctx.pictureModal.pictureModalFlag,
          "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.pictureModal.pictureModalFlag) = $event)),
          title: _ctx.pictureModal.pictureModalTitle,
          width: 500,
          centered: ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_a_button, {
              key: "submit",
              type: "primary",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.downloadImg(_ctx.pictureModal)))
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_image, {
              src: _ctx.pictureModal.pictureModalImg
            }, null, 8, ["src"])
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    (!_ctx.pictureModal.isImage)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 1,
          visible: _ctx.pictureModal.pictureModalFlag,
          "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.pictureModal.pictureModalFlag) = $event)),
          title: _ctx.pictureModal.pictureModalTitle,
          width: "100%",
          bodyStyle: { height: '450px' }
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_a_button, {
              key: "submit",
              type: "primary",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.downloadImg(_ctx.pictureModal)))
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("iframe", {
              name: "",
              src: _ctx.pictureModal.pdf,
              frameborder: "0",
              style: {"width":"100%","height":"100%"}
            }, null, 8, _hoisted_33)
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    (_ctx.rejectVisible)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 2,
          visible: _ctx.rejectVisible,
          "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.rejectVisible) = $event)),
          title: "拒绝原因",
          wrapClassName: "rejectCon",
          width: "40%",
          centered: "",
          onCancel: _ctx.closeReject
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_a_button, {
              key: "submit",
              type: "primary",
              onClick: _ctx.submitRejectReason
            }, {
              default: _withCtx(() => [
                _hoisted_34
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_textarea, {
              value: _ctx.rejectReason,
              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.rejectReason) = $event)),
              placeholder: "Please Input",
              allowClear: ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["visible", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.modalVisible)
      ? (_openBlock(), _createBlock(_component_notice_modal, {
          key: 3,
          modalVisible: _ctx.modalVisible,
          modalData: _ctx.modalData,
          onCloseModalVisible: _ctx.closeNoticeModal
        }, null, 8, ["modalVisible", "modalData", "onCloseModalVisible"]))
      : _createCommentVNode("", true)
  ], 64))
}